import Hosts from '../../Hosts';

//const object_type = 'Content'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/app/messages`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/app/messages/${companycode}`

const base_endpoint = '/app_messages'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        type: 'message',
        layout: 'normal',
        from: {
            id: '', 
            name: ''
        },
        to: {
            id: '', 
            name: ''
        },
        date: {
            received: '',
            read: '',
            replied: '',
        },
        tags: [],
        status: 'new'
    },
    content: [{
        subject: '',
        message: '',
        attachment: []
    }]
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
